export default "__VITE_ASSET__5e726bab__"